(function () {
  var MAX_RETRIES = 150;
  var RETRY_INTERVAL = 100;

  function ready(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }

  function avadaReady() {
    return !!(window.AVADA_BUNDLE && Array.isArray(window.AVADA_BUNDLE.allOffers));
  }

  function waitForAvada(attempts) {
    init();
    if (avadaReady()) return;
    if (hasNativeTierWidgets()) return;
    if (attempts >= MAX_RETRIES) {
      console.warn('[ux-bundle-sub] window.AVADA_BUNDLE not found after ' + (MAX_RETRIES * RETRY_INTERVAL) + 'ms');
      return;
    }
    setTimeout(function () {
      waitForAvada(attempts + 1);
    }, RETRY_INTERVAL);
  }

  function hasNativeTierWidgets() {
    return !!document.querySelector('[data-avada-bundle-quantity][data-bundle-tier-quantities]');
  }

  function init() {
    var widgets = document.querySelectorAll('[data-avada-bundle-quantity]');
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      if (widget.dataset.bundleRendered === '1') return;
      var productId = widget.getAttribute('data-product-id') || '';
      var productHandle = widget.getAttribute('data-product-handle') || '';
      var offer = avadaReady() ? pickOffer(productId, productHandle) : null;
      if (!offer) offer = buildNativeOffer(widget);

      if (!offer || !Array.isArray(offer.discountInformation) || !offer.discountInformation.length) {
        console.info('[ux-bundle-sub] No matching bundle tiers for product', { productId: productId, productHandle: productHandle });
        widget.setAttribute('hidden', '');
        return;
      }

      render(widget, offer);
    });
  }

  function buildNativeOffer(widget) {
    var quantitiesAttr = widget.getAttribute('data-bundle-tier-quantities') || '';
    if (!quantitiesAttr.trim()) return null;

    var quantities = quantitiesAttr
      .split(',')
      .map(function (value) {
        return parseInt(value.trim(), 10);
      })
      .filter(function (value) {
        return value > 0;
      });
    if (!quantities.length) return null;

    var discounts = (widget.getAttribute('data-bundle-tier-discounts') || '')
      .split(',')
      .map(function (value) {
        return Number(value.trim()) || 0;
      });
    var defaultQty = parseInt(widget.getAttribute('data-bundle-tier-default'), 10) || quantities[0];
    var discountType = widget.getAttribute('data-bundle-discount-type') || 'percentage';

    return {
      type: 'theme-native',
      discountType: discountType,
      discountInformation: quantities.map(function (quantity, index) {
        return {
          quantity: quantity,
          discountValue: discounts[index] || 0,
          isDefault: quantity === defaultQty,
        };
      }),
    };
  }

  function offerTriggersOnProduct(offer, productId, productHandle) {
    var cond = offer.triggerCondition;
    if (!cond || cond === 'all-products') return true;

    if (cond === 'specific-product') {
      var list = Array.isArray(offer.triggerProducts) ? offer.triggerProducts : [];
      return list.some(function (p) {
        if (!p) return false;
        if (productId && String(p.id) === String(productId)) return true;
        if (productHandle && p.handle && String(p.handle) === String(productHandle)) return true;
        return false;
      });
    }

    if (cond === 'specific-collection') {
      var ctx =
        (window.AVADA_BUNDLE &&
          window.AVADA_BUNDLE.product &&
          window.AVADA_BUNDLE.product.collections) ||
        [];
      var triggerCollections = Array.isArray(offer.triggerCollections) ? offer.triggerCollections : [];
      return triggerCollections.some(function (tc) {
        if (!tc) return false;
        return ctx.some(function (c) {
          if (!c) return false;
          if (tc.id && c.id && String(tc.id) === String(c.id)) return true;
          if (tc.handle && c.handle && String(tc.handle) === String(c.handle)) return true;
          return false;
        });
      });
    }

    return false;
  }

  function pickOffer(productId, productHandle) {
    var offers = (window.AVADA_BUNDLE && window.AVADA_BUNDLE.allOffers) || [];
    return offers.find(function (o) {
      return (
        o &&
        o.status === 'active' &&
        o.type === 'volume-discount' &&
        Array.isArray(o.discountInformation) &&
        o.discountInformation.length > 0 &&
        offerTriggersOnProduct(o, productId, productHandle)
      );
    });
  }

  function getMoneyFormat(widget) {
    if (widget) {
      var attr = widget.getAttribute('data-money-format');
      if (attr) return attr;
    }
    if (window.theme && window.theme.moneyFormat) return window.theme.moneyFormat;
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;
    var fromAvada =
      window.AVADA_BUNDLE &&
      window.AVADA_BUNDLE.shop &&
      window.AVADA_BUNDLE.shop.currencyFormats &&
      window.AVADA_BUNDLE.shop.currencyFormats.money_format;
    if (fromAvada) return fromAvada;
    return '${{amount}}';
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (cents == null || isNaN(cents)) return '0';
    if (precision == null) precision = 2;
    if (thousands == null) thousands = ',';
    if (decimal == null) decimal = '.';

    var amount = (cents / 100.0).toFixed(precision);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var fraction = parts[1] ? decimal + parts[1] : '';
    return dollars + fraction;
  }

  function formatMoney(amountCents, widget) {
    var format = getMoneyFormat(widget);
    var res;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      res = window.Shopify.formatMoney(amountCents, format);
    } else {
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = format.match(placeholderRegex);
      if (!match) return format;

      var value;
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(amountCents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(amountCents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(amountCents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(amountCents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(amountCents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(amountCents, 0, ' ', '.');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(amountCents, 2, "'", '.');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(amountCents, 2, ' ', '.');
          break;
        default:
          value = formatWithDelimiters(amountCents, 2);
      }

      res = format.replace(placeholderRegex, value);
    }
    // Amounts are presentment-currency cents. The money format comes from the
    // shop's base currency ("Dhs {{amount}}"), so force the active market
    // currency code as the label — e.g. "AED 88.00" -> "USD 88.00".
    if (res) {
      var code =
        (widget && widget.getAttribute('data-currency-code')) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        'AED';
      var lead = res.match(/^(\D+)([\d.,\s]+)$/);
      if (lead) {
        res = code + ' ' + lead[2].trim();
      } else {
        var trail = res.match(/^([\d.,\s]+)(\D+)$/);
        if (trail) res = code + ' ' + trail[1].trim();
      }
    }
    return res;
  }

  function applyDiscountCookie(code) {
    if (!code) return;
    try {
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'manual',
      }).catch(function () {});
    } catch (e) {
      /* fetch() not available — silently ignore. */
    }
  }

  function applyDiscount(totalCents, value, type) {
    var v = Number(value) || 0;
    if (type === 'fixed-amount' || type === 'fixed') {
      return Math.max(0, totalCents - v * 100);
    }
    return Math.round((totalCents * (100 - v)) / 100);
  }

  function discountLabel(value, type, widget) {
    if (type === 'fixed-amount' || type === 'fixed') {
      return formatMoney(Number(value) * 100, widget);
    }
    return value + '%';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoneySplit(amountCents, widget) {
    var formatted = formatMoney(amountCents, widget);
    var m = formatted.match(/^(\D+)([\d.,\s]+)$/);
    if (m) {
      return '<span class="bundle-selector__price-currency">' + escapeHtml(m[1].trim()) + '</span>' +
             '<span class="bundle-selector__price-number">' + escapeHtml(m[2].trim()) + '</span>';
    }
    var m2 = formatted.match(/^([\d.,\s]+)(\D+)$/);
    if (m2) {
      return '<span class="bundle-selector__price-currency">' + escapeHtml(m2[2].trim()) + '</span>' +
             '<span class="bundle-selector__price-number">' + escapeHtml(m2[1].trim()) + '</span>';
    }
    return '<span class="bundle-selector__price-number">' + escapeHtml(formatted) + '</span>';
  }

  function buildImageStack(qty, slotImageHtmls, fallbackHtml) {
    var n = Math.max(1, Math.min(3, qty));
    var slotHtml = '';
    if (slotImageHtmls && slotImageHtmls.length) {
      for (var i = n - 1; i >= 0; i--) {
        if (slotImageHtmls[i]) {
          slotHtml = slotImageHtmls[i];
          break;
        }
      }
    }
    if (!slotHtml) slotHtml = fallbackHtml;
    if (!slotHtml) return '';
    return (
      '<span class="bundle-selector__image bundle-selector__image--tier-' + n + '">' +
      slotHtml +
      '</span>'
    );
  }

  function render(widget, offer) {
    var list = widget.querySelector('[data-bundle-list]');
    if (!list) return;

    var basePrice = parseInt(widget.getAttribute('data-product-price'), 10) || 0;
    var radioName = widget.getAttribute('data-radio-name') || 'BundleTier';
    var idPrefix = widget.getAttribute('data-input-id-prefix') || radioName + '-';
    var sticksPerPack = parseInt(widget.getAttribute('data-sticks-per-pack'), 10) || 0;
    var stickLabel = widget.getAttribute('data-stick-label') || 'stick';
    var stickLabelPlural = widget.getAttribute('data-stick-label-plural') || '';

    var tiers = offer.discountInformation;
    var defaultIndex = tiers.findIndex(function (t) {
      return t && t.isDefault;
    });
    if (defaultIndex < 0) defaultIndex = 0;

    var imageSource = widget.querySelector('[data-product-image-source]');
    var innerImageHtml = imageSource ? imageSource.innerHTML : '';
    var slotImageHtmls = [1, 2, 3].map(function (slot) {
      var node = widget.querySelector('[data-bundle-image-slot="' + slot + '"]');
      return node ? node.innerHTML : '';
    });

    var offerCode = offer.code || '';

    var html = tiers
      .map(function (tier, idx) {
        var qty = parseInt(tier.quantity, 10) || 1;
        var discountValue = Number(tier.discountValue) || 0;
        var tierCode = tier && tier.code ? tier.code : offerCode;
        var fullTotal = basePrice * qty;
        var discountedTotal = applyDiscount(fullTotal, discountValue, offer.discountType);
        var perStickCents =
          sticksPerPack > 0 && qty > 0 ? Math.round(discountedTotal / (qty * sticksPerPack)) : 0;
        var packSingular = widget.getAttribute('data-pack-label-singular') || 'Pack';
        var packPlural = widget.getAttribute('data-pack-label-plural') || 'Packs';
        var titleText = qty + ' ' + (qty === 1 ? packSingular : packPlural);
        var packSubtitle = widget.getAttribute('data-pack-subtitle-' + (idx + 1)) || '';
        var inputId = idPrefix + qty;
        var hasDiscount = discountValue > 0;

        var badge = '';
        if (hasDiscount) {
          var saveLabel = 'Save ' + discountLabel(discountValue, offer.discountType, widget);
          badge =
            '<span class="bundle-selector__badge">' + escapeHtml(saveLabel) + '</span>';
        }

        var perStickHtml = '';
        if (sticksPerPack > 0) {
          var totalStickCount = qty * sticksPerPack;
          var stickLabelResolved = (totalStickCount > 1 && stickLabelPlural) ? stickLabelPlural : stickLabel;
          perStickHtml =
            '<span class="bundle-selector__per-pack">' +
            escapeHtml(formatMoney(perStickCents, widget)) +
            '/' + escapeHtml(stickLabelResolved) + '</span>';
        }

        var imageHtml = buildImageStack(qty, slotImageHtmls, innerImageHtml);

        var checkedAttr = idx === defaultIndex ? ' checked' : '';
        var selectedClass = idx === defaultIndex ? ' is-selected' : '';
        
        return (
          '<li class="bundle-selector__item">' +
          badge +
          '<input type="radio" class="bundle-selector__radio visually-hidden" name="' +
          escapeHtml(radioName) +
          '" id="' +
          escapeHtml(inputId) +
          '" data-price-total="' +
          escapeHtml(fullTotal) +
          '" data-discountedTotal="' +
          escapeHtml(discountedTotal) + 
          '" value="' +
          qty +
          '" data-discount="' +
          discountValue +
          '" data-discount-type="' +
          escapeHtml(offer.discountType || '') +
          '" data-discount-code="' +
          escapeHtml(tierCode) +
          '"' +
          checkedAttr +
          '>' +
          '<label for="' +
          escapeHtml(inputId) +
          '" class="bundle-selector__card' +
          selectedClass +
          '">' +
          imageHtml +
          '<span class="bundle-selector__text"><span class="bundle-selector__title">' +
          escapeHtml(titleText) +
          '</span>' +
          (packSubtitle ? '<span class="bundle-selector__subtitle">' + escapeHtml(packSubtitle) + '</span>' : '') +
          '<span class="bundle-selector__price">' +
          formatMoneySplit(discountedTotal, widget) +
          '</span>' +
          perStickHtml +
          '</span>' +
          '</label>' +
          '</li>'
        );
      })
      .join('');

    list.innerHTML = html;
    widget.dataset.bundleRendered = '1';
    widget.removeAttribute('hidden');

    var formId = widget.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var offerId = offer && (offer.id || offer._id || offer.offerId) ? String(offer.id || offer._id || offer.offerId) : '';

    widget.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || !t.classList || !t.classList.contains('bundle-selector__radio')) return;
      syncFormQuantity(widget, form, t);
      announceQty(widget, t);
      applyDiscountCookie(t.getAttribute('data-discount-code'));
      syncBundleProperty(form, offerId);
    });

    if (form && !form.dataset.bundleDiscountBound) {
      form.dataset.bundleDiscountBound = '1';
      // Capture phase so we run before product-form's submit handler builds FormData.
      form.addEventListener('submit', function () {
        var active = widget.querySelector('.bundle-selector__radio:checked');
        if (!active) return;
        syncFormQuantity(widget, form, active);
        applyDiscountCookie(active.getAttribute('data-discount-code'));
        syncBundleProperty(form, offerId);
      }, true);
    }

    var checked = widget.querySelector('.bundle-selector__radio:checked');
    if (checked) {
      syncFormQuantity(widget, form, checked);
      announceQty(widget, checked);
      applyDiscountCookie(checked.getAttribute('data-discount-code'));
      syncBundleProperty(form, offerId);
    }
  }

  // Inject `properties[_aov_bundles]` so AOV Bundle discount targets this line item.
  function syncBundleProperty(form, offerId) {
    if (!form || !offerId) return;
    var name = 'properties[_aov_bundles]';
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = JSON.stringify({ offerId: offerId });
  }

  function findQuantityInputs(widget, form) {
    var inputs = [];
    var seen = new Set();
    function add(el) {
      if (el && !seen.has(el)) {
        seen.add(el);
        inputs.push(el);
      }
    }
    // 1. dedicated bundle-owned input (lives inside the widget, form-associated via form attr)
    if (widget) {
      widget.querySelectorAll('[data-bundle-quantity-input]').forEach(add);
    }
    if (!form) return inputs;
    // 2. form-associated collection
    if (form.elements && form.elements.namedItem) {
      var fromElements = form.elements.namedItem('quantity');
      if (fromElements) {
        // namedItem can return RadioNodeList; normalize to single nodes
        if (fromElements instanceof Element) add(fromElements);
        else if (fromElements.length) Array.prototype.forEach.call(fromElements, add);
      }
    }
    // 3. inputs nested inside form
    if (form.querySelectorAll) {
      form.querySelectorAll('input[name="quantity"]').forEach(add);
    }
    // 4. document-wide inputs whose form attr points to this form
    if (form.id) {
      document
        .querySelectorAll('input[name="quantity"][form="' + form.id + '"]')
        .forEach(add);
    }
    return inputs;
  }

  function syncFormQuantity(widget, form, radio) {
    if (!radio) return;
    var qty = parseInt(radio.value, 10);
    if (Number.isNaN(qty) || qty < 1) return;
    var inputs = findQuantityInputs(widget, form);
    if (!inputs.length) {
      console.warn('[ux-bundle-sub] no quantity input found for form', form && form.id);
      return;
    }
    inputs.forEach(function (qtyInput) {
      if (String(qtyInput.value) === String(qty)) return;
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function announceQty(widget, radio) {
    var qty = parseInt(radio.value, 10) || 1;
    var discountValue = Number(radio.getAttribute('data-discount')) || 0;
    var discountType = radio.getAttribute('data-discount-type') || 'percentage';
    var discountCode = radio.getAttribute('data-discount-code') || '';
    var sectionId = widget.getAttribute('data-section-id') || '';
    var detail = {
      qty: qty,
      discountValue: discountValue,
      discountType: discountType,
      discountCode: discountCode,
      sectionId: sectionId,
    };
    widget.dispatchEvent(new CustomEvent('bundle:quantity-change', { bubbles: true, detail: detail }));
    document.dispatchEvent(new CustomEvent('bundle:quantity-change', { detail: detail }));
  }

  ready(function () {
    waitForAvada(0);
  });
  window.addEventListener('load', function () {
    if (avadaReady()) init();
  });
})();
